module.exports = __webpack_public_path__ + "ec972aae7bca87a0361fb7c51ce4e30a.svg";